import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
import Link from '../Link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faMapMarker,
  faCalendarPlus,
} from '@fortawesome/free-solid-svg-icons';

import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

import ProfileImage from '../profileImage';
import Markdown from '../Markdown';
import EmailLink from '../emailLink';

const TeamProfile = ({ profile, contactOnly }) => {
  return (
    <Grid
      container
      direction={{ xs: 'column', sm: 'row' }}
      columnSpacing={{ xs: 0, sm: 2 }}
      rowSpacing={{ xs: 2, sm: 2 }}
    >
      <Grid>
        <Box
          component={ProfileImage}
          sx={{ width: 150, height: 150, aspectRatio: '1/1' }}
          profile={profile}
        />
      </Grid>
      <Grid>
        <Typography variant="h5">
          {profile.name}
          {profile.firstName} {profile.lastName}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {profile.focus}
        </Typography>
        <Typography variant="body1">
          <Box
            component={FontAwesomeIcon}
            sx={{
              marginRight: 0.5,
            }}
            icon={faMapMarker}
            fixedWidth
          />
          {profile.city}, {profile.country}
        </Typography>
        <Box
          component="ul"
          sx={{
            listStyleType: 'none',
            padding: 0,
            margin: 0,
            li: {
              marginY: 0.25,
            },
          }}
        >
          {profile.email && (
            <li>
              <EmailLink email={profile.email}>
                <Box
                  component={FontAwesomeIcon}
                  sx={{
                    marginRight: 0.5,
                  }}
                  icon={faEnvelope}
                  fixedWidth
                />
                E-Mail senden
              </EmailLink>
            </li>
          )}
          {profile.bookingLink && (
            <li>
              <Link
                href={profile.bookingLink}
                target="_blank"
                rel="noreferrer"
                aria-label="Rückruf vereinbaren"
              >
                <Box
                  component={FontAwesomeIcon}
                  sx={{
                    marginRight: 0.5,
                  }}
                  icon={faCalendarPlus}
                  fixedWidth
                />
                Termin vereinbaren
              </Link>
            </li>
          )}
          {profile.linkedin && (
            <li>
              <Link
                href={profile.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <Box
                  component={FontAwesomeIcon}
                  sx={{
                    marginRight: 0.5,
                  }}
                  icon={faLinkedin}
                  fixedWidth
                />
                Auf LinkedIn hinzufügen
              </Link>
            </li>
          )}
        </Box>
      </Grid>
      {!contactOnly && profile.bio && (
        <Box
          sx={{
            marginTop: 2,
            marginLeft: { sm: 'calc(150px + 2rem)' },
          }}
        >
          <Markdown>{profile.bio.bio}</Markdown>
        </Box>
      )}
    </Grid>
  );
};

export default TeamProfile;
